<template>
    <GarudaContainer>
        <template slot="garuda:content">
            <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
                <div class="boxShadow setBorderRadius heig-frame-equipment-group">
                    <b-row no-gutters>
                        <b-col md="12" class="heig-frame-child">
                            <gofix-card class="mb-0 heig-frame-child" fullContent>
                                <gofix-table :settings="tableConfig"
                                    :table-items="tableItems"
                                    @new-item="openModalAdd"
                                    @load-items="getTableData"
                                    @row-click="clickToRowItem"
                                    @delete-items="deleteItems"
                                    @export="exportItems"
                                    ref="gofixTable">
                                    <!-- <template slot="gofix_table:upload_image" slot-scope="row">
                                        <div class="download-file" @click.stop="uploadImageGaruda(row.item.facility_id)">
                                            <i class="icon-cloud-upload icons font-2xl d-block"></i>
                                        </div>
                                    </template> -->
                                </gofix-table>
                            </gofix-card>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <b-modal :no-close-on-backdrop="true" id="modal-create-orders" title="Add new facilities" hide-footer :centered="true" v-model="modal.open" ref="modal-create-orders">
                <b-form class="formV2" v-bind:class="{'run-loading':modal.loading}">
                    <gofix-form-dropdown
                            label="Client Contract"
                            required
                            showIconRequired
                            :options="modal.options.contracts"
                            @search="searchContract"
                            v-model="modal.data.contract_id"
                            :filterable="false"
                            vLabel="contract_name"
                            :reduce="contract => contract.id">
                    </gofix-form-dropdown>
                    <gofix-form-properties
                            label="Property"
                            :contract-id="modal.data.contract_id"
                            required
                            showIconRequired
                            multiple
                            flat
                            :propertyIdsDisable="modal.propertyIdsDisable"
                            valueFormat="object" 
                            v-model="modal.data.property">
                    </gofix-form-properties>
                </b-form>
                <b-button-group class="d-block text-right pr-4">
                    <gofix-button label="SUBMIT" @click="createItem" :loading="modal.loading_btn" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
            <!-- <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments" id="modal-Contract-Attachments" hide-footer v-model="modalImport.open">
                <b-form class="formV2">
                    <b-form-group :label="modalImport.data.name" >
                        <b-form-file ref="file-input" v-model="modalImport.data.file" ></b-form-file>
                    </b-form-group>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="SUBMIT" @click="uploadAttachment" :loading="modalImport.loading" noBorder></gofix-button>
                    </b-button-group>
                </b-form>
            </b-modal> -->
            <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.downloading.title" hide-footer :centered="true" v-model="modals.downloading.open" hide-header-close>
                <b-progress :max="100" height="3rem" show-progress animated>
                <b-progress-bar :value="100">
                    <span class="font-size-16">Loading</span>
                </b-progress-bar>
                </b-progress>
            </b-modal>
        </template>
    </GarudaContainer>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    import GarudaContainer from '../default-view.vue'
    export default {
        name: 'facilities',
        components: {
            GarudaContainer
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['garuda_facilities']));
            return {
                tableConfig:{
                    name: 'garuda-facilities',
                    controls:{
                        create: true,
                        delete: false,
                        tableImport: false,
                        tableColumnSettings: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "facility_id",
                    sortDirection: "desc",
                    fields: [
                        // {
                        //     key: 'actions',
                        //     label: '',
                        //     width: 50,
                        //     thStyle: "width:50px",
                        // },
                        {
                            key: 'facility_id',
                            label: 'Facility ID',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            sorting: true,
                            with:150,
                        },
                        {
                            key: 'name',
                            label: 'Name',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            sorting: true,
                            with:150,
                        },
                        {
                            key: 'root_path',
                            label: 'Root path',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            sorting: true,
                            with:150,
                        },
                        {
                            key: 'type',
                            label: 'Type',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            sorting: true,
                            with:150,
                        },
                        // {
                        //     key: 'upload_image',
                        //     label: 'Upload image',
                        //     isActive: 1,
                        //     isFilter: true,
                        //     thStyle: "width:150px",
                        //     thClass: 'text-center',
                        //     tdClass: 'text-center',
                        //     sorting: true,
                        //     with:150,
                        // }
                    ],
                },
                tableItems: [],
                modal: {
                    open: false,
                    loading: false,
                    loading_btn: false,
                    data: {
                        contract_id: null,
                        property: null
                    },
                    options: {
                        contracts: []
                    },
                    propertyIdsDisable: []
                },
                modalImport: {
                    open: false,
                    loading: false,
                    data: {
                        file: null,
                        name: null,
                        facility_id: null
                    }
                },
                modals: {
                    downloading : {
                        open: false,
                        title: 'Downloading',
                    },
                }
            }
        },
        created() {
        },
        computed: {
            ...mapGetters({
                garudaToken: 'GarudaController/garudaToken',
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            "modal.data.contract_id": function(val) {
                this.modal.data.property = null
                this.modal.propertyIdsDisable = []
                this.getProperties()
            },
            "modalImport.data.file": function(val, old) {
                this.modalImport.data.name = 'Click Browse to upload file';
                if (val) {
                    let extensionArray = val.name.split('.');
                    let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                    if(!this.extensions.includes(extension)) {
                        this.$refs['file-input'].reset()
                        return this.$alertNotification("File format is incorrect. Please select a .csv, .xls, .xlsx, .docx, .doc, .pdf, .txt, .jpeg, .jpg, .png, .gif file!", "danger");
                    }
                    this.modalImport.data.name = val.name
                }
            },
        },
        methods: {
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                let contract = localStorage.getItem("ClientContractID")
                if(
                    (contract !== undefined && contract !== 'null' && contract !== '' && contract !== null && this.ClientContractID != null) &&
                    (
                        (tableRequest.filter.hasOwnProperty('contract_id') && ((tableRequest.filter.contract_id.hasOwnProperty('value') && !tableRequest.filter.contract_id.value) || !tableRequest.filter.contract_id))
                        || (tableRequest.filter.hasOwnProperty('client_contract_id') && ((tableRequest.filter.client_contract_id.hasOwnProperty('value') && !tableRequest.filter.client_contract_id.value) || !tableRequest.filter.client_contract_id))
                        || (tableRequest.filter.hasOwnProperty('contract_term_id') && ((tableRequest.filter.contract_term_id.hasOwnProperty('value') && !tableRequest.filter.contract_term_id.value) || !tableRequest.filter.contract_term_id))
                    )
                ) {
                    return
                }
                await this.$store.dispatch("GarudaController/getGarudaFacilities", tableRequest)
                    .then(response => {                        
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load facilities", "danger");
                        reject();
                    });
            },
            async getProperties() {
                await this.$store.dispatch("GarudaController/getGarudaFacilities", {
                    limit: -1,
                    page: 1,
                    isCMS: 1,
                    useDatabaseView: true,
                    filter: { contract_id: { type: "number", value: this.modal.data.contract_id, function: "=", with: [] } }
                }).then(response => {         
                    if(response.items && response.items.length)               
                        this.modal.propertyIdsDisable = response.items.map(item => item.id);
                })
                .catch(err => { console.log(err) });
            },
            async clickToRowItem(item){
                //
            },
            async deleteItems(callback){
                // const { ids,filter, resolve,reject } = await callback();
                // await this.$store.dispatch('OrderController/deleteItems', ids)
                //     .then(response => {
                //         resolve(this.$notificationV2('deleting', 'order'))
                //     })
                //     .catch(err => {
                //         reject();
                //     });
            },
            async getContract(search = '') {
                this.modal.loading = true
                await this.$store.dispatch('ContractController/getListClientContractsSearch', [1, {contract_name: search }, 1000])
                .then(response => {
                    this.modal.options.contracts = response.data
                    this.modal.loading = false
                }).catch(err => {
                    this.modal.loading = false
                })
            },
            searchContract(search, loading){
                this.modal.options.contracts = []
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch('ContractController/getListClientContractsSearch', [1, {contract_name: search }, 1000])
                        .then(response => {
                            this.modal.options.contracts = response.data
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },
            async openModalAdd() {
                if(!this.ClientContractID || (this.ClientContractID && !this.ClientContractID.hasOwnProperty('id'))) {
                    return this.$alertNotification("Please select contract", "danger");
                }

                this.modal.data.property = []
                this.modal.open = true;
                await this.getContract();
                this.modal.data.contract_id = await this.ClientContractID.id
                await this.getProperties()
            },
            createItem(){
                if(!this.modal.data.property) {
                    return this.$alertNotification("Please select the property", "danger");
                }

                let items = this.modal.data.property.filter(item => (item.children && item.children.length > 0) || (item.isBatch && item.isBatch == true));
                if(items.length) {
                    return this.$alertNotification("Please select the last level of properties", "danger");
                }

                this.modal.loading_btn = true
                let property_ids = this.modal.data.property.map(item => item.id)
                const params = {
                    property_ids: property_ids
                }
                this.$store.dispatch("GarudaController/createGarudaFacilities", params)
                    .then(async data => {
                        this.modal.loading_btn = false
                        this.modal.open = false
                        this.$alertNotification('Successfully added facility')
                        this.$refs.gofixTable.reloadTableItems();
                    })
                    .catch(err => {
                        this.modal.loading_btn = false
                        if(err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                            return this.$alertNotification(err.response.data.error.message, 'danger')
                        }
                        this.$alertNotification("Can't create new facility!", 'danger')
                    })
            },
            uploadImageGaruda(facility_id) {
                this.modalImport.data.facility_id = facility_id;
                this.modalImport.data.file = null
                this.modalImport.data.name = 'Click Browse to upload file'
                this.modalImport.open = true
            },
            uploadAttachment() {
                if (!this.modalImport.data.file) {
                    return this.$alertNotification("Please select a file", "danger");
                };

                this.modalImport.loading = false
                this.$store.dispatch('GarudaController/uploadImageForFacilities', {
                    facility_id: this.modalImport.data.facility_id,
                    file: this.modalImport.data.file
                })
                .then(result => {
                    this.isUpload = false
                    this.modalImport.open = false
                    // return this.$alertNotification(this.$notificationV2('editing', 'attachment'));
                }).catch(error => {
                    this.modalImport.loading = false
                })
            },
            exportItems(tableRequest){
                this.modals.downloading.open = true;
                this.$store.dispatch("GarudaController/exportFacilities", tableRequest)
                .then(response => {
                    if(response.data.size === 0) {
                        this.$alertNotification("Blank export", "warning");
                        return;
                    }

                    let nameFile = 'ExportFacilities.csv';
                    if(response.headers["content-disposition"]) {
                        let arrTemp = response.headers["content-disposition"].split("filename=");
                        if(arrTemp[1]) {
                            nameFile = arrTemp[1].replaceAll('"', "");
                        }
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile);
                    document.body.appendChild(link);
                    link.click();

                    this.modals.downloading.open = false;
                }).catch(err => {
                    this.modals.downloading.open = false;
                });
            },
        }
    }
</script>
